import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import './SectionHeader.scss';

const getCreditCardIcons = () => (
  <div className="SubscriptionActivate__SectionHeader__Content__Icons__Container">
    <div className="SubscriptionActivate__SectionHeader__Content__Icons__Container__Item">
      <img src="/images/credit-cards_mastercard.png" alt="img" width={30} height={20} />
    </div>
    <div className="SubscriptionActivate__SectionHeader__Content__Icons__Container__Item">
      <img src="/images/credit-cards_visa.png" alt="img" width={30} height={20} />
    </div>
    <div className="SubscriptionActivate__SectionHeader__Content__Icons__Container__Item">
      <img src="/images/credit-cards_amex.png" alt="img" width={30} height={20} />
    </div>
  </div>
);
export default function SectionHeader(props) {
  const { showCreditCardIcons } = props;

  return (
    <div className="SubscriptionActivate__SectionHeader__Content">
      <div className="SubscriptionActivate__SectionHeader__Content__Text">
        <div>
          {
            props.isEdit ?
              <span><img src="/images/icon/checkmark_grey.png" alt="img" width={18} />&nbsp;</span> :
              props.step && <span><FormattedMessage id={props.step} />.&nbsp;</span>
          }
        </div>
        <div>
          <FormattedMessage id={props.label} />
        </div>
      </div>
      {
        props.isEdit &&
        <div className="SubscriptionActivate__SectionHeader__Content__Link">
          <span
            onClick={() => props.handleEdit(props.activeSection)}
            role="button"
            tabIndex="0"
          >
            {props.actionLabel && <FormattedMessage id={props.actionLabel} />}
          </span>
        </div>
      }
      {
        showCreditCardIcons && getCreditCardIcons()
      }
    </div>
  );
}

SectionHeader.defaultProps = {
  handleEdit: () => {},
  activeSection: '',
  step: '',
  actionLabel: '',
  isEdit: false,
  showCreditCardIcons: false,
};

SectionHeader.propTypes = {
  step: PropTypes.string,
  label: PropTypes.string.isRequired,
  isEdit: PropTypes.bool.isRequired,
  handleEdit: PropTypes.func,
  activeSection: PropTypes.string,
  actionLabel: PropTypes.string,
  showCreditCardIcons: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/SectionHeader/SectionHeader.jsx